export const FETCH_VAT_LOGS_REQUEST = 'vat/fetch-vat-logs-request';
export const FETCH_VAT_LOGS_SUCCESS = 'vat/fetch-vat-logs-success';
export const FETCH_VAT_LOGS_FAILURE = 'vat/fetch-vat-logs-failure';
export const UPDATE_VAT_RETURN_LOG_STATUS = 'vat/update-vat-return-log-status';

export const FETCH_RUN_DATA_REQUEST = 'vat/fetch-run-data-request';
export const FETCH_RUN_DATA_SUCCESS = 'vat/fetch-run-data-success';
export const FETCH_RUN_DATA_FAILURE = 'vat/fetch-run-data-failure';
export const FETCH_VIEW_RUN_DATA_REQUEST = 'vat/fetch-view-run-data-request';

export const GENERATE_REPORT_REQUEST = 'vat/generate-report-request';
export const GENERATE_REPORT_SUCCESS = 'vat/generate-report-success';

export const GENERATE_REPORT_FAILURE = 'vat/generate-report-failure';
export const LOAD_REPORT_REQUEST = 'vat/load-report-request';
export const LOAD_REPORT_TOTALS_REQUEST = 'vat/load-report-totals-request';

export const LOAD_RECON_REQUEST = 'vat/load-recon-request';
export const LOAD_RECON_SUCCESS = 'vat/load-recon-success';
export const LOAD_RECON_FAILURE = 'vat/load-recon-failure';
export const CLEAR_RECONCILIATION_RUN = 'vat/clear-reconciliation-run';
/** Bump epoch + clear recon state when reconciliation generation fails or is superseded. */
export const RECON_GENERATE_LOAD_INVALIDATED =
  'vat/recon-generate-load-invalidated';

export const SAVE_RETURN_REQUEST = 'vat/save-return-request';
export const SAVE_RETURN_SUCCESS = 'vat/save-return-success';
export const SAVE_RETURN_FAILURE = 'vat/save-return-failure';

export const UPDATE_REPORT_FIELDS_REQUEST = 'vat/update-report-fields-request';
export const UPDATE_REPORT_FIELDS_SUCCESS = 'vat/update-report-fields-success';
export const UPDATE_REPORT_FIELDS_FAILURE = 'vat/update-report-fields-failure';

export const CANCEL_RETURN_REQUEST = 'vat/cancel-return-request';
export const CANCEL_RETURN_SUCCESS = 'vat/cancel-return-success';
export const CANCEL_RETURN_FAILURE = 'vat/cancel-return-failure';

export const UPDATE_ACTIVITY_ROLE_REQUEST = 'vat/update-activity-role-request';
export const UPDATE_ACTIVITY_ROLE_SUCCESS = 'vat/update-activity-role-success';
export const UPDATE_ACTIVITY_ROLE_FAILURE = 'vat/update-activity-role-failure';

export const ADD_NOTE_REQUEST = 'vat/add-note-request';
export const ADD_NOTE_SUCCESS = 'vat/add-note-success';
export const ADD_NOTE_FAILURE = 'vat/add-note-failure';

export const FETCH_ACTIVITY_LOGS_REQUEST = 'vat/fetch-activity-logs-request';
export const FETCH_ACTIVITY_LOGS_SUCCESS = 'vat/fetch-activity-logs-success';
export const FETCH_ACTIVITY_LOGS_FAILURE = 'vat/fetch-activity-logs-failure';

export const CHANGE_STATUS_AFTER_UPDATE = 'vat/change_status_after_update';

export const AWAITING_APPROVAL_REQUEST = 'vat/awaiting-approval-request';
export const AWAITING_APPROVAL_SUCCESS = 'vat/awaiting-approval-success';
export const AWAITING_APPROVAL_FAILURE = 'vat/awaiting-approval-failure';

export const CHANGE_ACTIVITY_ROLE = 'vat/change_activity_role';

export const INTERNALLY_APPROVE_REQUEST = 'vat/internally-approve-request';
export const INTERNALLY_APPROVE_SUCCESS = 'vat/internally-approve-success';
export const INTERNALLY_APPROVE_FAILURE = 'vat/internally-approve-failure';

export const SEND_CLIENT_APPROVAL_REQUEST = 'vat/send-client-approval-request';
export const SEND_CLIENT_APPROVAL_SUCCESS = 'vat/send-client-approval-success';
export const SEND_CLIENT_APPROVAL_FAILURE = 'vat/send-client-approval-failure';

export const CLIENT_APPROVE_REQUEST = 'vat/client-approve-request';
export const CLIENT_APPROVE_SUCCESS = 'vat/client-approve-success';
export const CLIENT_APPROVE_FAILURE = 'vat/client-approve-failure';

export const NOT_APPROVE_REQUEST = 'vat/not-approve-request';
export const NOT_APPROVE_SUCCESS = 'vat/not-approve-success';
export const NOT_APPROVE_FAILURE = 'vat/not-approve-failure';

export const SUBMIT_RETURN_REQUEST = 'vat/submit-return-request';
export const SUBMIT_RETURN_SUCCESS = 'vat/submit-return-success';
export const SUBMIT_RETURN_FAILURE = 'vat/submit-return-failure';
export const SUBMIT_HMRC_RETURN_REQUEST = 'vat/submit-hmrc-return-request';
export const SUBMIT_HMRC_RETURN_SUCCESS = 'vat/submit-hmrc-return-success';
export const SUBMIT_HMRC_RETURN_FAILURE = 'vat/submit-hmrc-return-failure';

export const LOCK_RETURN_REQUEST = 'vat/lock-return-request';
export const LOCK_RETURN_SUCCESS = 'vat/lock-return-success';
export const LOCK_RETURN_FAILURE = 'vat/lock-return-failure';

export const RESET_VAT_DATA = 'vat/reset-vat-data';

export const CHECK_ENTITY_STATUS_REQUEST = 'vat/check-entity-status-request';
export const CHECK_ENTITY_STATUS_SUCCESS = 'vat/check-entity-status-success';
export const CHECK_ENTITY_STATUS_FAILURE = 'vat/check-entity-status-failure';

export const FETCH_EXCEL_FILE_REQUEST = 'vat/fetch-excel-file-request';
export const FETCH_EXCEL_FILE_SUCCESS = 'vat/fetch-excel-file-success';
export const FETCH_EXCEL_FILE_FAILURE = 'vat/fetch-excel-file-failure';

export const EXCEPTIONS_ACTION_REQUEST = 'vat/exceptions-action-request';
export const EXCEPTIONS_ACTION_SUCCESS = 'vat/exceptions-action-success';
export const EXCEPTIONS_ACTION_FAILURE = 'vat/exceptions-action-failure';

export const MANUAL_JOURNAL_POST_REQUEST = 'vat/manual-journal-post-request';
export const MANUAL_JOURNAL_POST_SUCCESS = 'vat/manual-journal-post-success';
export const MANUAL_JOURNAL_POST_FAILURE = 'vat/manual-journal-post-failure';

export const SET_UPDATE_FROM_PAGE = 'vat/set-update-from-page';

export const FETCH_DATA_PAGE_REQUEST = 'vat/fetch-data-page-request';
export const FETCH_DATA_PAGE_REQUEST_SUCCESS =
  'vat/fetch-data-page-request-success';
export const SET_CURRENT_JOURNALS_PAGE = 'vat/set-current-journals-page';
export const FETCH_TRANSACTION_FILTERS = 'vat/fetch-transaction-filters';
export const SET_TRANSACTION_FILTERS = 'vat/set-transaction-filters';
export const EXPORT_TO_CSV_REQUEST = 'vat/export-to-csv-request';
export const EXPORT_TO_EXCEL_REQUEST = 'vat/export-to-excel-request';
export const EXPORT_TO_EXCEL_DONE = 'vat/export-to-excel-done';
export const EXPORT_TO_CSV_DONE = 'vat/export-to-csv-done';

export const FETCH_TRANSACTION_ATTACHMENT_REQUEST =
  'vat/fetch-transaction-attachment-request';
export const FETCH_TRANSACTION_ATTACHMENT_SUCCESS =
  'vat/fetch-transaction-attachment-success';
export const FETCH_TRANSACTION_ATTACHMENT_FAILURE =
  'vat/fetch-transaction-attachment-failure';

export const FETCH_METADATA_ATTACHMENTS_REQUEST =
  'vat/fetch-metadata-attachments-request';
export const FETCH_METADATA_ATTACHMENTS_SUCCESS =
  'vat/fetch-metadata-attachments-success';
export const FETCH_METADATA_ATTACHMENTS_FAILURE =
  'vat/fetch-metadata-attachments-failure';
export const CLEAR_METADATA_ATTACHMENTS = 'vat/clear-metadata-attachments';

export const UPLOAD_TRANSACTION_ATTACHMENT_REQUEST =
  'vat/upload-transaction-attachment-request';
export const UPLOAD_TRANSACTION_ATTACHMENT_SUCCESS =
  'vat/upload-transaction-attachment-success';
export const UPLOAD_TRANSACTION_ATTACHMENT_FAILURE =
  'vat/upload-transaction-attachment-failure';

export const FETCH_ATTACHMENTS_REQUEST = 'FETCH_ATTACHMENTS_REQUEST';
export const FETCH_ATTACHMENTS_SUCCESS = 'FETCH_ATTACHMENTS_SUCCESS';
export const FETCH_ATTACHMENTS_FAILURE = 'FETCH_ATTACHMENTS_FAILURE';

export const CANCEL_VAT_SAGA = 'vat/cancel-vat-saga';
export const LOAD_REPORT_SUCCESS = 'vat/load-report-success';
export const UPDATE_SUMMARIZED_DATA_SIZE = 'vat/update-summarized-data-size';
export const TOUCH_REPORT = 'vat/touch-report';
export const REFRESH_REPORT_REQUEST = 'vat/refresh-report-request';
